import {Button, Modal} from "react-bootstrap";
import {FormGenerator} from "./FormGenerator";
import {TemplateDto} from "../TemplateDto";
import {FormikProps} from "formik";
import {useRef} from "react";

type TemplateFormModalProps = {
    show: boolean;
    onClose: () => void;
    template?: TemplateDto;
    // loading?: boolean;
};

export const TemplateFormModal = ({show, onClose, template}: TemplateFormModalProps) => {

    const formikRef = useRef<FormikProps<any>>(null);

    const handleSubmitClick = () => {
        formikRef.current?.submitForm();
    };

    function flattenObject(obj: Record<string, any>, prefix = ''): Record<string, any> {
        let result: Record<string, any> = {};

        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const value = obj[key];
            const newKey = prefix ? `${prefix}.${key}` : key;

            if (value && typeof value === 'object' && !Array.isArray(value)) {
                Object.assign(result, flattenObject(value, newKey));
            } else {
                result[newKey] = value;
            }
        }

        return result;
    }

    const handleFormSubmit = (values: any) => {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = `api/repositories/solidify/templates/${template?.manifest.name}/${template?.manifest.version}/generate`;
        form.target = "_blank";

        Object.entries(flattenObject(values)).forEach(([key, value]) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = value as string;
            form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);

        onClose();
    };

    return (<Modal show={show} onHide={onClose} size="lg" backdrop="static" centered>
        <Modal.Header closeButton>
            <Modal.Title>Create <b>{template && template.manifest.name + ":" + template.manifest.version}</b></Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {template && <FormGenerator
                schema={template.schema}
                defaults={template.defaults}
                onSubmit={handleFormSubmit}
                ref={formikRef}
            />}
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>
                Anuluj
            </Button>
            <Button variant="primary" onClick={handleSubmitClick}>
                Zapisz
            </Button>
        </Modal.Footer>
    </Modal>)
}